export const SUIT_CHARS = {
  Hearts: '\u2665',
  Diamonds: '\u2666',
  Spades: '\u2660',
  Clubs: '\u2663',
};

export const FACE_RANKS = new Set(['K', 'Q', 'J']);

export function isRedSuit(suit) {
  return suit === 'Hearts' || suit === 'Diamonds';
}